/**
 * tourAutoFireDecision — the guided tour's first-run auto-fire gate, pure so
 * it's testable (Layout.tsx applies the result).
 *
 * The tour auto-fires for new users on the /brief LANDING — and "landing"
 * is load-bearing (bug, user-reported 2026-07-12): a bare pathname check fired
 * the tour on ANY landing-route arrival, so a signal drill ("Open the
 * Workload board" → /pipeline?keys=…) ambushed the investigation with the
 * tour. Two rules encode "landing":
 *  - a query string means drill intent (the user was sent here to look at
 *    something specific) — never fire on top of it;
 *  - the auto-fire is spent by the first counted /brief arrival per app
 *    load — later visits are navigation, not a first run. ("Take the tour"
 *    in the sidebar stays the deliberate re-entry.)
 * An arrival only counts once the steps are loaded — before that we can't
 * decide, so it neither fires nor spends.
 *
 * The landing itself moved from /pipeline to /brief 2026-07-20 (Brian: "the
 * brief [should be] the opening page, not the workload page") — this gate
 * moved with it so the tour still auto-fires exactly once, on the real
 * landing, and never on a mid-tour or drill arrival at /pipeline.
 */
export function tourAutoFireDecision(opts: {
  tourCompletedAt: string | null | undefined;
  carouselOpen: boolean;
  stepsLoaded: boolean;
  pathname: string;
  search: string;
  spent: boolean;
}): { fire: boolean; spend: boolean } {
  const { tourCompletedAt, carouselOpen, stepsLoaded, pathname, search, spent } = opts;
  if (pathname !== '/brief' || !stepsLoaded) return { fire: false, spend: false };
  // An open carousel defers the decision (don't compete with it, and don't
  // spend the arrival — the tour may still fire once it closes).
  if (carouselOpen) return { fire: false, spend: false };
  const fire = !spent && !search && !tourCompletedAt;
  return { fire, spend: true };
}
